import enLocale from './en'

export default {
  Growth: {
    rentalTitle: "Pasaran Sewaan",
    rentalDesc: "Sewa lesen daripada pemegang lain; senaraikan milik anda untuk hasil",
    listingCount: "Disenaraikan",
    avgDailyRent: "Sewa harian purata",
    deals7d: "Urus niaga (7h)",
    totalRent: "Jumlah sewa",
    termLabel: "Tempoh",
    dailyRent: "Sehari",
    annualized: "Tahunan",
    rentNow: "Sewa sekarang",
    sortDaily: "Ikut sewa/hari",
    sortTerm: "Ikut tempoh",
    sortPrice: "Ikut harga",
    sortNewest: "Terbaru",

    leaderboard: "Papan Pendahulu",
    leaderboardDesc: "Kedudukan pedagang berdasarkan keputusan sebenar di rantaian",
    winRate: "Kadar menang",
    bets: "Pertaruhan",
    volume: "Volum",
    record: "{w}M · {l}K",
    winLose: "M / K",
    loadMore: "Muat lagi",
    empty: "Tiada data",
    trader: "Pedagang",
    rankLabel: "Kedudukan",
    selling: "Sedang dijual",
    recent: "Keputusan terkini",
    none: "Tiada",
    follow: "Salin",
    modeSale: "Jualan",
    modeRental: "Sewaan",
    day: "h",
    periodAll: "Semua",
    period90: "90h",
    period30: "30h",
    period7: "7h",
    sortRoi: "Mengikut ROI",
    sortProfit: "Mengikut P&L",
    sortWinRate: "Mengikut kadar menang",
    sortVolume: "Mengikut volum",
    sortBets: "Mengikut pertaruhan",
    referralCenter: "Pusat Rujukan",
    referralRewards: "Ganjaran Rujukan",
    referralRewardsDesc: "Jemput rakan, kongsi ganjaran bersama dan pantau kolam VIP",
    myMode: "Mod saya",
    modeTeam: "Pasukan",
    modeAgent: "Ejen",
    l1Rate: "Kadar L1",
    l2Rate: "Kadar L2",
    myUpline: "Upline saya",
    uplineNone: "Tiada",
    myVip: "Tahap VIP",
    vipNotEnabled: "Kolam VIP tidak diaktifkan",
    vipNext: "Tahap seterusnya",
    vipDirect: "Terus",
    vipAsset: "Aset peribadi",
    vipTeamQualified: "Pasukan layak",
    vipPools: "Kolam layak",
    tabTeam: "Pasukan",
    teamLevel: "Tahap",
    teamMembers: "Ahli",
    tabCommission: "Komisen",
    commLevel: "Tahap",
    commRate: "Kadar",
    commAmount: "Jumlah",
    statusPending: "Menunggu",
    statusSettled: "Selesai",
    channelOnChain: "On-chain",
    channelPlatform: "Platform",
    communityGroup: "Komuniti & lagi",
    referralDesc: "Jemput rakan, kembangkan komuniti, dan peroleh komisen daripada aktiviti mereka.",
    connectFirst: "Sambungkan dompet anda untuk membuka pusat rujukan",
    directInvites: "Jemputan langsung",
    totalDownline: "Jumlah pasukan",
    earned: "Jumlah komisen",
    pendingClaim: "Menunggu tuntutan",
    myReferrer: "Dirujuk oleh",
    inviteLink: "Pautan jemputan anda",
    copy: "Salin",
    copied: "Disalin!",
    linkHint: "Rakan yang membuka pautan ini dan membuat pengikatan on-chain akan dikira sebagai jemputan anda.",
    tabInvitees: "Jemputan saya",
    tabRewards: "Sejarah komisen",
    tabTop: "Penaja teratas",
    invitesCol: "Jemputan",
    typeInvite: "Jemputan",
    typeReward: "Komisen",
    typeWithdraw: "Pengeluaran",
    bindTitle: "Pautkan perujuk anda",
    bindDesc: "Pautan disimpan di pelayan mengikut alamat dompet, jadi ia kekal pada mana-mana peranti.",
    bindPlaceholder: "Masukkan alamat perujuk (0x...)",
    bindButton: "Tandatangan & pautkan",
    bindFromLink: "Daripada pautan jemputan",
    bindLocked: "Perujuk hanya boleh ditetapkan sekali.",
    bindSuccess: "Perujuk dipautkan",
    bindFailed: "Pautan gagal",
    bindSelf: "Anda tidak boleh memautkan diri sendiri",
    bindCancelled: "Tandatangan dibatalkan",
  },
  progress: "Kemajuan",
  timeLeft: "{t} lagi",
  ended: "Tamat",
  fundTitle: "Dana",
  fundDesc: "Baki kontrak dan wallet bagi setiap token yang disokong",
  token: "Token",
  contractBalance: "Baki kontrak",
  lockedAmount: "Dikunci",
  unlockTime: "Buka kunci dalam",
  depositToContract: "Deposit ke kontrak",
  withdrawToWallet: "Keluarkan ke wallet",
  available: "Tersedia",
  max: "Maks",
  withdraw: "Keluar",
  deposit: "Deposit",
  approve: "Lulus",
  withdrawTip: "Pengeluaran dikunci seketika sebelum sampai ke wallet anda.",
  connectWallet: "Sambung wallet",
  ...enLocale,

  language: 'Bahasa',
  confirm: 'Sahkan',
  go: 'Pergi',
  status: 'Status',
  balance: 'Baki',
  cash: 'Tunai',
  createNew: 'Cipta Baru',
  home: 'Laman Utama',
  market: 'Pasaran',
  markets: 'Pasaran',
  community: "Komuniti",
  deposit: "Deposit",
  bridge: "Jambatan",
  portfolio: 'Portfolio',
  license: 'Lesen',
  withdraw: 'Pengeluaran',
  auditChecking: 'Sedang disemak',
  insufficientFunds: 'Dana tidak mencukupi',
  buy: 'Beli',
  history: 'Sejarah',
  seeMore: 'Lihat lagi',
  theme: 'Tema',
  network: 'Rangkaian',
  walletBalance: 'Baki Dompet',
  collect: 'Terima',
  approve: 'Luluskan',
  ticket: 'Lesen',
  category: 'Kategori',
  sortBy: 'Susun mengikut',
  issue: 'Terbit',
  detail: 'Butiran',
  stakingType: 'Koleteral',
  stakingTypeInfo: 'Untuk elak pengesahan tidak wajar, sila stake token atau NFT semasa.',
  subscriptionAmount: 'Jumlah Pembelian',
  subscription: 'Langganan',
  subscribe: 'Beli',
  max: 'Maks',
  marketClosed: 'Pasaran Ditutup',
  deposit: 'Tambah',
  verifiedNFT: 'Semak Lesen',
  select: 'Pilih',
  selected: 'Dipilih',
  moreNFT: 'Dapatkan lebih banyak Lesen',
  forecastEvent: 'Acara',
  subscribeEndDate: 'Hari Dagangan Terakhir',
  specifyExpiryDate: 'Tetapkan Tarikh Luput',
  endDate: 'Tarikh Tamat',
  validityPeriod: 'Tarikh Luput',
  marketEndDate: 'Tarikh Luput',
  liquidityMin: 'Kecairan Minimum',
  premiumMin: 'Premium Minimum',
  paymentCurrency: 'Mata Wang Pembayaran',
  defaultOdds: 'Leveraj Lalai',
  setDefaultOdds: 'Tetapkan Leveraj',
  minInvestAmout: 'Tetapkan Jumlah Pelaburan Minimum',
  depositMargin: 'Tambah Kecairan',
  totalPayment: 'Jumlah Bayaran',
  rewards: 'Ganjaran',
  rewardRate: 'Kadar Ganjaran',
  release: 'Lepaskan',
  fee: 'Fi',
  marginFeeRate: 'Kadar Fi',
  cdsInfoOne: 'Apabila menerbitkan produk ramalan, stake margin, tetapkan leveraj dan jumlah minimum.',
  cdsInfoTwo: 'Margin yang tidak digunakan boleh dikeluarkan pada bila-bila masa.',
  cdsInfoThree: 'Jika lebih daripada seorang membuat rayuan, komuniti akan menentukan keputusan.',
  deposited: 'Dilabur',
  issued: 'Diterbitkan',
  depositedCDS: 'Produk dilabur',
  totalProfit: 'Untung Keseluruhan',
  allOrDeposited: 'Jumlah/Dilabur',
  rewardsOrProfit: 'Ganjaran/Untung',
  estimatedInvested: 'Anggaran/Dilabur',
  profit: 'Untung',
  yesterdayProfit: 'Untung Semalam',
  eventConfirming: 'Pengesahan acara',
  appeal: 'Rayuan',
  appealing: 'Sedang buat rayuan',
  appealFailed: 'Rayuan gagal',
  occured: 'Berlaku',
  notOccured: 'Tidak berlaku',
  governanceMechanism: 'Mulakan tadbir urus apabila rayuan melebihi seorang.',
  appealLimit: 'Bilangan rayuan tidak melebihi seorang.',
  waitResult: 'Menunggu Keputusan Rayuan',
  frozenMargin: 'Margin Dibekukan',
  marginBalance: 'Baki Margin',
  cancel: 'Batal',
  defaultAhead: 'Berlaku Awal',
  occur: 'Berlaku',
  notOccur: 'Tidak berlaku',
  stakingToChallenge: 'Stake untuk Mencabar',
  challenged: 'Telah mencabar',
  checking: 'Menyemak',
  fail: 'Gagal',
  endTime: 'Kiraan detik ke tamat',
  guaranteeing: 'Sedang berjalan',
  guaranteeingEvent: 'Ramalan sedang berlangsung',
  confirmsEventAdvance: 'Pengesahan berlaku awal',
  waitConfirmation: 'Menunggu pengesahan',
  triggerEvent: 'Disahkan berlaku',
  notTriggerEvent: 'Disahkan tidak berlaku',

  appealInfoOne: 'Jika keputusan acara tidak tepat, anda boleh “Mencabar” dan biar komuniti menentukan.',
  check: 'Semak',
  contentIllegal: 'Acara ramalan mengandungi kandungan tidak sesuai. Sila sunting semula.',
  subscribed: 'Produk dilabur',
  receivingCompensation: 'Tertunda',
  received: 'Jumlah Bayaran',
  receive: 'Terima',
  compensationAmount: 'Jumlah pampasan jika berlaku',
  liquidity: 'Kecairan',
  injectLiquidity: 'Suntik Kecairan',
  uRLContent: 'URL/Kandungan',
  resolutionSource: 'Sumber Rujukan',
  textareaInfo: 'Sila terangkan acara ini secara ringkas.',

  issuerResult: 'Keputusan Penerbit',
  daoResult: 'Keputusan DAO',
  waitingGovernanceResult: 'Menunggu keputusan tadbir urus.',
  eventFinished: 'Acara selesai.',
  recycleTicket: 'Kitar semula lesen',
  eventCancelled: 'Acara dibatalkan.',
  challenge: 'Cabaran',
  share: 'Kongsi',
  USDT: 'USDT',
  donations: 'Derma',

  issueMsgPleaseSelectLicense: 'Sila pilih lesen',
  issueMsgLicenseCannotBeStaked: 'Lesen tidak boleh di-stake',
  issueMsgNetworkNotConnected: 'Rangkaian belum disambungkan',
  issueMsgEventEmpty: 'Acara kosong',
  issueMsgSelectLicense: 'Pilih lesen',
  issueMsgLastTradingDateEmpty: 'Hari dagangan terakhir kosong',
  issueMsgExpirationDateEmpty: 'Tarikh luput kosong',
  issueMsgOptionsEmpty: 'Pilihan tidak boleh kosong',
  issueMsgOptionsLessThanTwo: 'Pilihan mestilah sekurang-kurangnya dua',
  issueMsgOptionEmpty: 'Pilihan kosong',
  issueMsgOptionRepeated: 'Pilihan berulang',
  issueMsgLastTradingDateGreaterThanToday: 'Hari dagangan terakhir mesti lebih besar daripada hari ini',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'Hari dagangan terakhir melebihi tarikh luput',
  issueMsgLicenseError: 'Ralat lesen',
  issueMsgTicketError: 'Ralat tiket',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'Tarikh tamat {eventEndDate} melebihi tarikh tamat sewa {rentalEndDate}',
  issueMsgInsufficientBalance: 'Baki tidak mencukupi',
  issueMsgTransactionFailed: 'Transaksi gagal',
  issueMsgIssueSuccess: 'Terbit berjaya',
  issueMsgTransactionCancelled: 'Transaksi dibatalkan',

  short: {
    ...enLocale.short,
    confirmsEventAdvance: 'Berlaku awal',
    waitConfirmation: 'Menunggu pengesahan',
    defaultChallenging: 'Berlaku-Sedang cabar',
    notDefaultChallenging: 'Tidak berlaku-Sedang cabar',
    defaultChallengeFailed: 'Berlaku-Cabaran gagal',
    notDefaultChallengeFailed: 'Tidak berlaku-Cabaran gagal',
    defaultWaitingResult: 'Berlaku-Menunggu tadbir urus',
    notDefaultWaitingResult: 'Tidak berlaku-Menunggu tadbir urus',
    defaultGovernanceMechanism: 'Berlaku-Disahkan tadbir urus',
    notDefaultGovernanceMechanism: 'Tidak berlaku-Disahkan tadbir urus',
  },

  wallet: {
    ...enLocale.wallet,
    openWallet: 'Buka dompet',
    connectWallet: 'Sambung dompet',
    connectingWallet: 'Menyambung dompet',
    connectYourWallet: 'Sambungkan dompet anda',
    disconnect: 'Putuskan sambungan',
    wrongNetwork: 'Rangkaian tidak betul',
  },

  NFT: {
    ...enLocale.NFT,
    getPrediLicense: 'Dapatkan Lesen Predi',
    referralRewards: 'Ganjaran Rujukan',
    mintYourLicence: 'Mint lesen anda',
    usageRights: 'Hak penggunaan',
    issuePredictionProducts: 'Terbit produk ramalan',
    governance: 'Tadbir urus',
    properties: 'Ciri',
    tradable: 'Boleh didagangkan',
    rentable: 'Boleh disewa',
    usable: 'Boleh digunakan',
    marketsToIssue: 'Pasaran untuk diterbitkan',
    times: 'Kali',
    availableTimes: 'Kali tersedia',
    ticketId: 'ID Tiket',
    cancelRentHint: 'Lesenกำลัง disewa, batalkan sebelum menjual.',
    seeMore: 'Lihat lagi',
    sell: 'Jual',
    rent: 'Sewa',
    share: 'Kongsi',
    common: 'Biasa',
    scarcity: 'Jarang',
    attributive: 'Berkaitan',
    numbers: 'Nombor terbitan',
    issueTip: 'Terbit 10 pasaran ramalan setiap lesen',
    price: 'Harga',
    success: 'Berjaya',
    getNFT: 'Berjaya mendapatkan lesen',
    issueCDS: 'Terbit Pasaran Predi',
    buyNow: 'Beli sekarang',
    mintNow: 'Mint sekarang',
    rule: 'Peraturan',
    comingSoon: 'Akan datang!',
    type: 'Jenis',
    from: 'Dari',
    to: 'Ke',
    me: 'Saya',
    rented: 'Telah disewa',
    sold: 'Telah dijual',
    tabGetLicense: 'Dapatkan Lesen',
    tabMyLicense: 'Lesen Saya',
    tabMarket: 'Pasaran',
    marketDisabled: "Pasaran sekunder belum tersedia.",
    bought: 'Telah beli',
    boughtProducts: 'Produk dibeli',
    investedProducts: 'Produk dilabur',
    issuedProducts: 'Produk diterbitkan',
    positions: 'Posisi',
    options: 'Pilihan',
    all: 'Semua',
    volume: 'Volum',
    newest: 'Terbaru',
    pending: 'Tertunda',
    audit: 'Audit',
    loading: 'Memuatkan',
    empowering: 'Memperkasakan penglihatan meramal masa depan',
    myPositions: 'Posisi Saya',
    challengeCredit: 'Kredit cabaran',
    challengeStatus: 'Status cabaran',
    succeed: 'Berjaya',
    wait: 'Tunggu',
    return: 'Kembali',
    createYourOwnMarket: 'Cipta pasaran anda',
    waitChallenge: 'กำลังรอ cabaran',
    waitingGovernanceResult: 'กำลังรอ keputusan tadbir urus',
    eventFinished: 'Acara selesai',
    cancelled: 'Dibatalkan',
    predictionProduct: 'Produk ramalan',
    complaintCountdown: 'Kiraan detik aduan',
    setResult: 'Tetapkan keputusan',
    recycleTicket: 'Kitar semula lesen',
    eventCancelled: 'Acara dibatalkan',
    auditChecking: 'Sedang disemak',
    insufficientFunds: 'Dana tidak mencukupi',
    buyTicket: 'Beli Tiket',
    listYourToken: 'Senarai token anda',
  },

  claim: {
    ...enLocale.claim,
    title: 'Tuntut PRDs Percuma',
    subtitle: 'Dapatkan token PRDs dengan sekali klik',
    walletAddress: 'Alamat Dompet',
    status: 'Status',
    connectWalletFirst: 'Sila sambung dompet terlebih dahulu',
    eligibility: {
      claimed: 'Anda telah menuntut',
      eligible: 'Anda layak menuntut',
      error: 'Ralat semak kelayakan',
    },
    button: {
      claim: 'Tuntut',
      alreadyClaimed: 'Telah dituntut',
      connect: 'Sambung',
    },
    footerNotice: 'Setiap dompet hanya boleh menuntut sekali. Pastikan rangkaian betul.',
    messages: {
      connectFirst: 'Sila sambung dompet dahulu',
      claimSuccess: 'Tuntutan berjaya!',
      claimFailed: 'Tuntutan gagal, cuba lagi kemudian',
      txCancelled: 'Transaksi dibatalkan',
      onlyOnce: 'Setiap pengguna hanya menuntut sekali',
      insufficientBalance: 'Baki kontrak tidak mencukupi, cuba lagi kemudian',
    },
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'Sila masukkan kandungan carian',
  predictionProduct: 'Produk ramalan',
  listYourToken: 'Senarai token anda',
  description: 'Penerangan',
  positions: 'Posisi',
  options: 'Pilihan',
  all: 'Semua',
  volume: 'Volum',
  newest: 'Terbaru',
  pending: 'Tertunda',
  audit: 'Audit',
  loading: 'Memuatkan',
  challengeCredit: 'Kredit cabaran',
  challengeStatus: 'Status cabaran',
  succeed: 'Berjaya',
  wait: 'Tunggu',
  return: 'Kembali',
  waitChallenge: 'Sedang menunggu cabaran',
  complaintCountdown: 'Kiraan detik aduan',
  setResult: 'Tetapkan keputusan',
  issueParticipateUntil: 'Pengguna boleh mengambil bahagian dalam produk ini sehingga',
  specifyLastTradingDate: 'Tetapkan masa dagangan terakhir',
  empowering: 'Memperkasakan penglihatan meramal masa depan',
  amount: 'Jumlah',
  createYourOwnMarket: 'Cipta pasaran anda sendiri',
  
  licenses: 'Lesen',
  prediLicense: 'Lesen Predi',
  issuableQuantity: 'Kuantiti boleh diterbitkan',
  disabled: 'Dilumpuhkan',
  battleImage: 'Imej bukti',
  upload: 'Muat naik',
  showSample: 'Lihat sampel',
  battleInformation: 'Maklumat bukti',
  baseToken: 'Token asas',
  collateral: 'Koleteral',
  currentLicense: 'Lesen semasa',
  predictionProject: 'Projek ramalan:',
  issueExpireIntro: 'Pada masa tamat tempoh, mereka yang memilih pilihan yang betul akan berkongsi token dari kolam produk berdasarkan saham penyertaan mereka.',
  issueConfirmAdvance: 'Hasilnya boleh disahkan terlebih dahulu oleh penerbit, jika acara berlaku sebelum masa tamat tempoh.',
  issueChallengeWithin7Days: 'Jika peserta tidak bersetuju dengan hasil acara yang disahkan oleh penerbit, mereka boleh "Mencabar" dalam tempoh 7 hari selepas pengesahan.',
  issueAttention: 'Perhatian: Predi komited untuk memupuk hiburan dan pengalaman sosial. Semua bentuk aktiviti berkaitan perjudian dilarang sama sekali di platform ini.',
  eventSampleTitle: 'Acara',
  issueSampleCrypto: '[Kripto] Apakah julat harga Bitcoin pada akhir 2025?',
  issueSampleFinance: '[Kewangan] Apakah keputusan kadar faedah Federal Reserve AS pada Q3 2025?',
  issueSampleTechnology: '[Teknologi] Syarikat mana akan melancarkan pembantu robot AI berkendiri penuh pertama?',
  issueSampleSports: '[Sukan] Pasukan mana akan memenangi Piala Dunia FIFA 2026?',
  issueSampleSociety: '[Masyarakat] Platform media sosial mana yang akan mempunyai pengguna bulanan paling aktif pada 2025?',
  issueSampleOthers: '[Lain-lain] Bilakah perang Rusia-Ukraine akan berakhir?',
  issuerResult: 'Hasil penerbit',
  daoResult: 'Hasil DAO',
  predictionToken: 'Token ramalan',
  issuer: 'Penerbit',
  issuerProfit: 'Keuntungan penerbit'
}